import { Controller } from "@hotwired/stimulus"
import { backStorageKey } from "./back_storage"

// Remembers the URL of the list you are looking at — search, filter, sort and
// page included — so a detail page can send you back to exactly that list.
//
//   .row data-controller="back-save"
//
// See back_restore_controller.js for the other half.
export default class extends Controller {
  static values = { key: String }

  connect() {
    sessionStorage.setItem(backStorageKey(this), window.location.href)
  }
}
